<div class="main-content">
  <app-header
    [title]="('COMPANY_GROUP_USERS.HEADER_TITLE' | translate) + (companyGroupName ? ': ' + companyGroupName : '')"
    [subtitle]="'COMPANY_GROUP_USERS.HEADER_SUBTITLE' | translate"
  />

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'user'" iconHeight="24px">
        <app-table
          [allValues$]="users$"
          [type]="'company_group_user'"
          [hasChart]="false"
          [filters$]="userFilter$"
          (selectedFilter)="onFilterSelected($event)"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [totalPages]="totalPages"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="true"
          [keywordFilterName]="'keyword'"
          [keywordFilterPlaceholder]="'FILTER.SEARCH_USERS'"
          [showTitle]="true"
        />
      </app-icam-container>
    </div>
  </div>

  <div class="mt-4 mb-4">
    <app-back-button
      [linkText]="'COMPANY_GROUP_USERS.BACK'"
      (click)="goBack()"
    />
  </div>
</div>
<app-footer-copyright />
